module.exports = __webpack_public_path__ + "img/mobile_frame.c45e8795.png";